module.exports = __webpack_public_path__ + "img/Sk_resident2ru.1fc6054e.webp";